import React, { useContext, useEffect, useId } from 'react';

import Spinner from '#@/components/Spinner';

import { PageLoaderRegistryContext } from './PageLoaderRegistry';
import StyledPageLoader from './Styles';

const PageLoader: React.FC = () => {
  const id = useId();
  const ctx = useContext(PageLoaderRegistryContext);

  useEffect(() => {
    if (ctx) {
      ctx.addPageLoader(id);
      return () => ctx.removePageLoader(id);
    }
    return undefined;
  });

  return (
    <StyledPageLoader data-cy-page-loader>
      <Spinner size={70} />
    </StyledPageLoader>
  );
};

export default PageLoader;
